import viewsProvider from './utilities/viewsProvider';

const skyVisible = (function skyVisible() {
	// window variables
	const scrollPosition = {
		x: window.pageXOffset,
		y: window.pageYOffset,
		deltaY: 0,
		deltaX: 0,
	};

	const windowDimensions = {
		width: window.innerWidth,
		height: window.innerHeight,
	};

	// Get the document height - assume it's the highest number
	let documentHeight = Math.max(
		document.body.scrollHeight,
		document.body.offsetHeight,
		document.documentElement.clientHeight,
		document.documentElement.scrollHeight,
		document.documentElement.offsetHeight);

	// List of all elements and their preferences
	const items = [];

	// Different calculations
	const views = viewsProvider;

	// Default view preferences
	const defaults = {
		// Take the offset above fold into account
		foldOffset: true,
		// Makes sure progress reaches 1 when
		// bottom of page is reached
		bottomOffset: true,
		// Caches the value - prevents executing callback
		// if value is the same
		cache: true,
		// Cap progress between 0 and 1
		cap: true,
		// Flush: skip cache or not (true = skip)
		// flush: false,
	};

	// Debounce variable for refresh timeout
	let refreshDebounce = 0;

	/**
	 * Get an element from the items list
	 *
	 * @param {DOMElement|string} element - the element or string
	 * @return {DOMElement|boolean} - if nothing found false is returned
	 */
	function getElement(element) {
		if (element instanceof Element) {
			return element;
		}

		// if (angular.isElement(element)) {
		// 	return element[0];
		// }

		if (Array.isArray(element)) {
			return element[0];
		}

		return element;
	}

	/**
	 * Get the index of an item, that
	 * has a giving element
	 *
	 * @param {node|string} element
	 * @return {number}
	 */
	function getItemIndex(element) {
		let index = -1;
		for (let i = 0; i < items.length; i++) {
			const item = items[i];

			if (element instanceof Element && item.node === element) {
				index = i;
				break;
			}

			if (typeof element === 'string' && element === item.name) {
				index = i;
				break;
			}
		}

		return index;
	}

	/**
	 * Get an item based on element
	 *
	 * @param {node} element
	 * @return {object}
	 */
	function getItem(element) {
		// If angular element or normal element
		element = getElement(element);
		const index = getItemIndex(element);
		return items[index];
	}

	/**
	 * This methods does all the calculations and exposes
	 * methods for recalculation and checking views
	 *
	 * @param {node} element
	 */
	function itemSetup(element) {
		// element = element instanceof Element ? element : angular.element(element);

		// Element properties
		const boundingRect = element.getBoundingClientRect();

		const dimensions = {
			height: element.offsetHeight,
			width: element.offsetWidth,
			top: boundingRect.top + scrollPosition.y - document.documentElement.clientTop,
			left: boundingRect.left + scrollPosition.x - document.documentElement.clientLeft,
			boundingClientRect: boundingRect,
		};

		// const elementHeight = element.offsetHeight;
		// const elementBoundingRect = element.getBoundingClientRect();
		// const elementOffsetTop =
		//elementBoundingRect.top + scrollPosition.y - document.documentElement.clientTop;

		// var viewVariables = {};

		const item = getItem(element);

		// angular.element(element).on('$destroy skyVisible:unbind', destroy);

		/**
		 * Checks rather the element is visible in the defined
		 * views. It will then loop over them and dispatch an event
		 * with the given values
		 *
		 * @param {boolean} flush - skip cache
		 */
		// function checkViews(flush = false) { // Nødvendig?
		function checkViews() {
			const _element = item.node;
			const methods = item.methods;

			for (let j = 0; j < methods.length; j++) {
				const method = methods[j];
				const callback = method.method;
				const view = method.view;
				const preferences = method.preferences;
				let value;

				if (views[view] && typeof callback === 'function') {
					let shouldUpdate = true;

					if (preferences.shouldUpdate !== undefined) {
						shouldUpdate = preferences.shouldUpdate;
						if (preferences.shouldUpdate instanceof Function) {
							shouldUpdate = preferences.shouldUpdate.call(element, dimensions, scrollPosition);
						}
					}

					if (shouldUpdate) {
						// Get value
						value = views[view]
							.call(
								undefined,
								_element,
								dimensions,
								scrollPosition,
								windowDimensions.height,
								documentHeight,
								preferences);

						const valueIsUnchanged = Object.keys(value).reduce((previousValues, key) => {
							if (previousValues) {
								return method.value && (key in method.value) && value[key] === method.value[key];
							}
							return false;
						}, true);

						// If value has changed
						if (!valueIsUnchanged) {
							callback.call(_element, value, dimensions, scrollPosition, windowDimensions);
							method.value = value;
						}
					}
				}
			}
		}

		/**
		 * Recalculates variables
		 * Function added to onResize
		 */
		function recalculate() {
			const _boundingRect = element.getBoundingClientRect();

			dimensions.height = _boundingRect.height ? _boundingRect.height : element.offsetHeight;
			dimensions.width = _boundingRect.width ? _boundingRect.width : element.offsetWidth;
			dimensions.top = _boundingRect.top + scrollPosition.y - document.documentElement.clientTop;
			dimensions.left = _boundingRect.left + scrollPosition.x - document.documentElement.clientLeft;
			dimensions.boundingClientRect = _boundingRect;

			checkViews();
		}

		item.recalculate = recalculate;
		item.checkViews = checkViews;
		item.dimensions = dimensions;

		/**
		 * Unbind and remove resize/scroll methods
		 */
		// function destroy() {
		// 	removeItems(element);
		// 	// angular.element(element).off('$destroy skyVisible:unbind', destroy);
		// }
	}

	/**
	 * Create an item with a givin element,
	 * if non found, and returns the item
	 *
	 * @param {node} element
	 * @return {object}
	 */
	function addItem(element, name = null) {
		element = getElement(element);

		let index = getItemIndex(element);

		// Add to items and store item
		if (index === -1) {
			index = -1 + items.push({
				methods: [],
			});


			// Added as reference
			if (typeof element === 'string') {
				items[index].name = element;

				// Added as element
			} else {
				items[index].node = element;
				itemSetup(element);
			}

			// Added as references before element
		} else if (!items[index].node && element instanceof Element) {
			items[index].node = element;
			itemSetup(element);
		}

		if (name) {
			items[index].name = name;
		}

		return items[index];
	}

	/**
	 * Removes items, based on their element
	 *
	 * @param {array} elements
	 */
	function removeItems(elements) {
		elements = elements.length !== undefined ? elements : [elements];

		for (let i = 0; i < elements.length; i++) {
			const index = getItemIndex(elements[i]);
			if (index !== -1) {
				items.splice(index, 1);
			}
		}
	}

	/**
	 * Runs through all methods in onScrollMethods
	 *
	 * Makes sure the methods are only run after the scroll
	 * position and window position is calculated
	 *
	 * @param {node} element [optional]
	 * @param {boolean} checkCache [optional]
	 */
	function checkItemsViews(element = false, checkCache = true) {
		element = element ? getElement(element) : false;

		// Get scroll position
		const position = {
			y: window.pageYOffset,
			x: window.pageXOffset,
		};

		// Prevent running methods if position not changed
		if (position.y === scrollPosition.y && position.x === scrollPosition.x && checkCache) {
			return;
		}

		if (scrollPosition.y !== position.y) {
			scrollPosition.deltaY = position.y - scrollPosition.y;
		}
		if (scrollPosition.x !== position.x) {
			scrollPosition.deltaX = position.x - scrollPosition.x;
		}

		scrollPosition.y = position.y;
		scrollPosition.x = position.x;

		// Dont check views if scroll beyond screen
		if (scrollPosition.y < 0 || scrollPosition.x < 0) {
			return;
		}

		function checkItemViews(item) {
			if (typeof item.checkViews === 'function') {
				item.checkViews(true);
			}
		}

		if (element) {
			checkItemViews(getItem(element));
			return;
		}

		for (let i = 0; i < items.length; i++) {
			checkItemViews(items[i]);
		}
	}

	/**
	 * Runs on resize debounce.
	 * Iterates through onResizeMethods
	 *
	 * Makes sure the resize methods are run after the window and
	 * document height is calculated
	 */
	function recalculateItems(element) {
		element = element ? getElement(element) : false;

		// Get the window height
		windowDimensions.height = window.innerHeight;
		windowDimensions.width = window.innerWidth;
		documentHeight = Math.max(
			document.body.scrollHeight,
			document.body.offsetHeight,
			document.documentElement.clientHeight,
			document.documentElement.scrollHeight,
			document.documentElement.offsetHeight);

		function recalculateItem(item) {
			if (!item) {
				return;
			}

			for (const method in item.methods) {
				// Clear all save item.methods[method] valyes
				// if `flush` preference true
				if (item.methods[method].preferences && item.methods[method].preferences.flush) {
					delete item.methods[method].value;
				}

				// If recalculated item.methods[method] specified - fire it
				if (item.methods[method].preferences && typeof item.methods[method].preferences.recalculate === 'function') {
					item.methods[method].preferences.recalculate.apply(item.node, [
						scrollPosition,
						windowDimensions,
					]);
					checkItemsViews(item.node);
				}
			}

			// If theres a shouldRecalculate method, make sure it returns true
			if ((typeof item.shouldRecalculate === 'function' && item.shouldRecalculate())
				|| item.shouldRecalculate === undefined
				|| item.shouldRecalculate) {
				if (typeof item.recalculate === 'function') {
					item.recalculate();
				}
			}
		}

		if (element) {
			recalculateItem(getItem(element));
			return;
		}

		for (let i = 0; i < items.length; i++) {
			recalculateItem(items[i]);
		}
	}

	/**
	 * Convenience method for calling both recalculateItems and
	 * checkItemViews
	 *
	 * Has an optional debounce.
	 *
	 * @param {number} debounce [optional]
	 */
	function recalculateAndCheckItems(debounce) {
		function recalculateAndCheckItemsMethod() {
			recalculateItems(false);
			checkItemsViews(null, false);
		}

		if (!debounce) {
			// If no debounce, refresh immediately
			recalculateAndCheckItemsMethod();
		} else {
			// Debounce
			clearTimeout(refreshDebounce);
			refreshDebounce = setTimeout(recalculateAndCheckItemsMethod, debounce);
		}
	}

	/**
	 * Adds a method to an item. The element is used to find
	 * the specific item - if non found it will create one
	 *
	 * The used item will be returned
	 *
	 * @param {node} element
	 * @param {string} view [outer]
	 * @param {object} preferences
	 * @param {function} method
	 * @return {object}
	 */
	function addMethod(element, view, preferences, method) {
		// The element item
		const item = addItem(element);

		view = view || 'outer';
		preferences = Object.assign({}, defaults, (preferences || {}));

		// Add a view if givin
		// Adds to array of views
		if (item.methods.length) {
			item.methods.push({
				view,
				method,
				preferences,
			});
			// Creates an array of views
		} else {
			item.methods = [{
				view,
				method,
				preferences,

			}];
		}

		return item;
	}

	/**
	 * Public method that adds methods to a view, for
	 * a given element
	 *
	 * @param {array} elements
	 * @param {string} view
	 * @param {object} preferences [optional]
	 * @param {function} method
	 */
	function addMethods(elements, view = null, preferences = null, method = null) {
		elements = Array.isArray(elements) ? elements : [elements];

		// View is left out (Checking if it's an object)
		if (view !== null && view.toString() === '[object Object]') {
			method = preferences;
			preferences = view;
			view = '';

			// view and preferences are left out
		} else if (typeof view === 'function') {
			method = view;
			preferences = {};
			view = '';

			// Preferences is left out
		} else if (typeof preferences === 'function') {
			method = preferences;
			preferences = {};
		}

		for (let i = 0; i < elements.length; i++) {
			const element = getElement(elements[i]);
			addMethod(element, view, preferences, method);
		}

		// Assume other elements affected
		checkItemsViews();
	}

	/**
	 * Public method that removes a method from a
	 * bunch of element
	 * @param {array} elements
	 * @param {string} view
	 * @param {function} method
	 */
	function removeMethods(elements = null, view = null, method = null) {
		// Filter out methods based on view & method
		function filterMethods(_item) {
			if (!method && view) {
				return _item.view !== view;
			} else if (method && !view) {
				return _item.method !== method;
			}

			return !(_item.method === method && _item.view === view);
		}

		elements = elements.length !== undefined ? elements : [elements];

		// View is left out
		if (typeof view === 'function') {
			method = view;
			view = '';
		}

		// If no method or view, remove entire item
		if (!method && !view) {
			removeItems(elements);
			return;
		}

		for (let i = 0; i < elements.length; i++) {
			const element = getElement(elements[i]);
			const item = getItem(element);

			item.methods = item.methods.filter(filterMethods);
		}
	}

	/**
	 * Give an item a reference name. The element
	 * is used to find an item
	 *
	 * @param {node} element
	 * @param {string} name
	 * @return {object}
	 */
	function setReference(element, name) {
		const reference = getItem(name);

		const item = addItem(element, name);

		// Merge reference methods
		if (reference) {
			item.methods = item.methods.concat(reference.methods);
			delete items.splice(getItemIndex(name), 1);
		}

		return item;
	}

	/**
	 * Look up an item by reference name
	 *
	 * @param {string} name
	 * @return {object|boolean}
	 */
	// function getReference(name) {
	// 	const item = getItem(name) || {};
	// 	return item.node || false;
	// }

	/**
	 * Return the dimensions object based
	 * on the an element or reference name
	 *
	 * @param {node|string}
	 * @return {object}
	 */
	function getDimensions(element) {
		const item = getItem(element);

		return item.dimensions || {};
	}

	// Exposes public methods
	return {
		setReference,
		getReference: getItem,

		bind: addMethods,
		unbind: removeMethods,

		refresh: recalculateAndCheckItems,
		recalculate: recalculateItems,
		checkViews: checkItemsViews,

		getDimensions,
	};
}());

export default skyVisible;



// WEBPACK FOOTER //
// ./scripts/sky-visible/sky-visible.js